export default "__VITE_ASSET__BAw5XCPT__"